import { ParsedItem } from 'store/declaration-form-errors/ParsedForm';

/**
 * The product an item error is about. The error carries the id of its item; only declaration
 * types whose items cannot be found by id have to fall back on the position, which is the
 * position in the stored items and so only matches the list when it is the whole list in its
 * stored order.
 */
const getErrorItemProductId = (item: ParsedItem | undefined, products: { id?: string }[] | undefined) => {
    if (!item) return undefined;

    return item.id ?? products?.at(item.index - 1)?.id;
};

export default getErrorItemProductId;
